import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
export var DescriptionText = function (props) {
    var className = namespacedClassnames('deprecated-text', 'description-text', props.className);
    return React.createElement("p", { className: className }, props.children);
};
export var LightDescriptionText = function (props) {
    var className = namespacedClassnames('deprecated-text', 'light-description-text', props.className);
    return React.createElement("p", { className: className }, props.children);
};
//# sourceMappingURL=texts.js.map